import * as Yup from "yup";

export const initialValues = {
  resourceName: "",
  resourceDescription: "",
  resourceLink: "",
};

export const getValidationSchema = () =>
  Yup.object().shape({
    resourceName: Yup.string().required("This field is required"),
    resourceDescription: Yup.string().required("This field is required"),
  });
